// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2u-iI","label":"Labeled_label__3odxp","divider":"Labeled_divider__3iAMq"};